import { useEffect, useState } from "react";

import { useDebounce } from "~/client/hooks/useDebounce";

export const useDebounceTextChange = (callback: (text: string) => void, text: string, debounceTime: number = 500) => {
  const [changing, setChanging] = useState(true);

  useDebounce(
    () => {
      callback(text);
      setChanging(false);
    },
    debounceTime,
    [text],
  );

  useEffect(() => {
    setChanging(true);
  }, [text]);

  return [changing] as const;
};
